import { flip as y, shift as b, offset as U, arrow as v, size as I, autoPlacement as H, hide as T, inline as D, computePosition as E } from "../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs";
import { isTextSelection as M, posToDOMRect as C } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { Plugin as R, PluginKey as z, NodeSelection as P } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { CellSelection as V } from "../../node_modules/prosemirror-tables/dist/index.mjs";
function x(d, t) {
  const e = Math.min(d.top, t.top), h = Math.max(d.bottom, t.bottom), r = Math.min(d.left, t.left), a = Math.max(d.right, t.right) - r, u = h - e, n = r, o = e;
  return new DOMRect(n, o, a, u);
}
class B {
  constructor({
    editor: t,
    element: e,
    view: h,
    updateDelay: r = 250,
    resizeDelay: f = 60,
    shouldShow: a,
    appendTo: u,
    getReferencedVirtualElement: n,
    options: o
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "top",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1,
      onShow: void 0,
      onHide: void 0,
      onUpdate: void 0,
      onDestroy: void 0
    }, this.shouldShow = ({
      view: s,
      state: i,
      from: l,
      to: c
    }) => {
      const { doc: p, selection: m } = i, { empty: g } = m, w = !p.textBetween(l, c).length && M(i.selection), O = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || O) || g || w || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.documentMousedownHandler = (s) => {
      var l;
      const i = s.target;
      this.element.contains(i) || this.view.dom.contains(i) || (l = i.closest) != null && l.call(i, "[data-headlessui-portal]") || this.hide();
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var i;
      if (this.editor.isDestroyed) {
        this.destroy();
        return;
      }
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && ((i = this.element.parentNode) != null && i.contains(s.relatedTarget)) || (s == null ? void 0 : s.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.handleDebouncedUpdate = (s, i) => {
      const l = !(i != null && i.selection.eq(s.state.selection)), c = !(i != null && i.doc.eq(s.state.doc));
      !l && !c || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, l, c, i);
      }, this.updateDelay));
    }, this.updateHandler = (s, i, l, c) => {
      const { composing: p } = s;
      if (p || !i && !l)
        return;
      if (!this.getShouldShow(c)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.transactionHandler = ({ transaction: s }) => {
      s.getMeta("bubbleMenu") === "updatePosition" && this.updatePosition();
    }, this.editor = t, this.element = e, this.view = h, this.updateDelay = r, this.resizeDelay = f, this.appendTo = u, this.scrollTarget = (o == null ? void 0 : o.scrollTarget) ?? window, this.getReferencedVirtualElement = n, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...o
    }, this.element.tabIndex = 0, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), document.addEventListener("mousedown", this.documentMousedownHandler), this.update(h, h.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  get middlewares() {
    const t = [];
    return this.floatingUIOptions.flip && t.push(
      y(
        typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0
      )
    ), this.floatingUIOptions.shift && t.push(
      b(
        typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0
      )
    ), this.floatingUIOptions.offset && t.push(
      U(
        typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0
      )
    ), this.floatingUIOptions.arrow && t.push(v(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && t.push(
      I(
        typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0
      )
    ), this.floatingUIOptions.autoPlacement && t.push(
      H(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && t.push(
      T(
        typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0
      )
    ), this.floatingUIOptions.inline && t.push(
      D(
        typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0
      )
    ), t;
  }
  get virtualElement() {
    var f, a, u;
    const { selection: t } = this.editor.state, e = (f = this.getReferencedVirtualElement) == null ? void 0 : f.call(this);
    if (e)
      return e;
    if (!((u = (a = this.view) == null ? void 0 : a.dom) != null && u.parentNode))
      return;
    const h = C(this.view, t.from, t.to);
    let r = {
      getBoundingClientRect: () => h,
      getClientRects: () => [h]
    };
    if (t instanceof P) {
      let n = this.view.nodeDOM(t.from);
      const o = n.dataset.nodeViewWrapper ? n : n.querySelector("[data-node-view-wrapper]");
      o && (n = o), n && (r = {
        getBoundingClientRect: () => n.getBoundingClientRect(),
        getClientRects: () => [n.getBoundingClientRect()]
      });
    }
    if (t instanceof V) {
      const { $anchorCell: n, $headCell: o } = t, s = n ? n.pos : o.pos, i = o ? o.pos : n.pos, l = this.view.nodeDOM(s), c = this.view.nodeDOM(i);
      if (!l || !c)
        return;
      const p = l === c ? l.getBoundingClientRect() : x(
        l.getBoundingClientRect(),
        c.getBoundingClientRect()
      );
      r = {
        getBoundingClientRect: () => p,
        getClientRects: () => [p]
      };
    }
    return r;
  }
  updatePosition() {
    const t = this.virtualElement;
    t && E(t, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: e, y: h, strategy: r }) => {
      this.element.style.width = "max-content", this.element.style.position = r, this.element.style.left = `${e}px`, this.element.style.top = `${h}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(t, e) {
    const { state: h } = t, r = h.selection.from !== h.selection.to;
    if (this.updateDelay > 0 && r) {
      this.handleDebouncedUpdate(t, e);
      return;
    }
    const f = !(e != null && e.selection.eq(t.state.selection)), a = !(e != null && e.doc.eq(t.state.doc));
    this.updateHandler(t, f, a, e);
  }
  getShouldShow(t) {
    var n;
    const { state: e } = this.view, { selection: h } = e, { ranges: r } = h, f = Math.min(...r.map((o) => o.$from.pos)), a = Math.max(...r.map((o) => o.$to.pos));
    return ((n = this.shouldShow) == null ? void 0 : n.call(this, {
      editor: this.editor,
      element: this.element,
      view: this.view,
      state: e,
      oldState: t,
      from: f,
      to: a
    })) || !1;
  }
  show() {
    var e;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1", (e = (typeof this.appendTo == "function" ? this.appendTo() : this.appendTo) ?? this.view.dom.parentElement) == null || e.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), document.removeEventListener("mousedown", this.documentMousedownHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}
const N = (d) => new R({
  key: typeof d.pluginKey == "string" ? new z(d.pluginKey) : d.pluginKey,
  view: (t) => new B({ view: t, ...d })
});
export {
  N as BubbleMenuPlugin,
  B as BubbleMenuView
};
